// components/Modals/CloneRenameSchedualerModal.js

import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { handleGetAvailableRegionsByCropId } from "../../store/actions/cropActions";

const CloneRenameSchedualerModal = ({
  show,
  handleClose,
  mode = "clone", // or "rename"
  regionList = [], // list of { id, region } objects
  initialRegionId = null,
  onSubmit,
  initialName = "",
  schedualerCrop, // crop id for cloning
}) => {

    const dispatch = useDispatch();

      // Fetch available regions by crop ID
  useEffect(() => {
  if (mode === "clone" && schedualerCrop) {
    console.log("Inside Modal - Fetching regions for crop ID:", schedualerCrop);
    handleGetAvailableRegionsByCropId(dispatch, schedualerCrop);
  }
}, [dispatch, schedualerCrop, mode]);


  const { availableCropRegionList = [] } = useSelector((state) => state.crop || {});
console.log("availableCropRegionList:", availableCropRegionList, schedualerCrop);
  const [schedualerName, setSchedualerName] = useState(initialName);
  const [regionId, setRegionId] = useState(initialRegionId || "");
  // const [error, setError] = useState("");
// Always keep error as an object
const [error, setError] = useState({ name: "", region: "" });
 

  useEffect(() => {
    setSchedualerName(initialName || "");
    setRegionId(initialRegionId || "");
    setError({ name: "", region: "" });

  }, [initialName, initialRegionId, show]);



  const handleSubmit = () => {
    const newErrors = {};
    if (!schedualerName.trim()) newErrors.name = "Name is required.";
  if (mode === "clone" && !regionId) newErrors.region = "Region is required.";

    if (Object.keys(newErrors).length > 0) {
    setError(newErrors);
    return;
  }

  onSubmit(schedualerName.trim(), regionId);
  };

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>
          {mode === "clone" ? "Clone Schedualer" : "Rename Schedualer"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group>
<Form.Label>
  {mode === "clone" ? (
    <>
      New Scheduler Name <span style={{ color: "red" }}>*</span>
    </>
  ) : (
    "Edit Name"
  )}
</Form.Label>


          <Form.Control
            type="text"
            placeholder="Enter scheduler name"
            value={schedualerName}
            onChange={(e) => setSchedualerName(e.target.value)}
            isInvalid={!!error.name}

          />
          <Form.Control.Feedback type="invalid">{error.name}</Form.Control.Feedback>
        </Form.Group>

         {mode === "clone" && (
          <Form.Group>
            <Form.Label>Select Region<span style={{ color: 'red' }}>*</span></Form.Label>
            <Form.Select
              value={regionId}
              onChange={(e) => setRegionId(e.target.value)}
              isInvalid={!!error.region}
            >
              <option value="">-- Select Region --</option>
              {availableCropRegionList?.regions?.map((region) => (

                <option key={region.id} value={region.id}>
                  {region.region}
                </option>
              ))}
            </Form.Select>
            <Form.Control.Feedback type="invalid">{error.region}</Form.Control.Feedback>

          </Form.Group>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button className="cancel-button mx-2" onClick={handleClose}>Cancel</Button>
        <Button className="button" onClick={handleSubmit}>
          {mode === "clone" ? "Clone" : "Update"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CloneRenameSchedualerModal;
